export default "__VITE_ASSET__cae81146__"